import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import BlockUI from '../../component/BlockUI';
import { RenderInputWithDiv } from '../../component/formInput';
import SdnsConfigModal from './modals/SdnsConfigModal';


var _ = require("lodash")
function RecordManage(record_data, onShowRecordConfigModal, onDeleteRecord) {
  const record_rows = _.map(record_data, (item, index) => {
    return (
      <tr key={index}>
        <td>
          <strong>{item.name}</strong>
        </td>
        <td>
          <strong>{item.type}</strong>
        </td>
        <td style={{lineBreak: "anywhere"}}>
          <strong>{item.content}</strong>
        </td>
        <td>
          <strong>{item.prio}</strong>
        </td>
        <td style={{textAlign: 'center'}} >
          <div style={{display: "inline-flex"}}>
            <button onClick={()=>onShowRecordConfigModal(item)} className="btn bg-orange" aria-hidden="true">Sửa</button> 
            <button onClick={()=>onDeleteRecord(item.id)} className="btn" aria-hidden="true">Xóa</button> 
          </div>
        </td>
      </tr>
    )
  })
  return (
    <div className="table-responsive">
      <table style={{fontSize: ".8125rem"}} className="table table-xs">
        <thead>
        <tr>
          <th>Host</th>
          <th>Type</th>
          <th>Content</th>
          <th>Priority</th>
          <th style={{textAlign: "center"}}>Action</th>
        </tr>
        </thead>
        <tbody>
        {record_rows}
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td style={{textAlign: "right", right: 0, position: "sticky"}}>
              <button onClick={()=>onShowRecordConfigModal(null)} className="btn bg-primary"> + Thêm</button> 
            </td>
        </tr>
        </tbody>
      </table>
      <h4>Ghi chú</h4>
      <ul>
        <li>
          Nếu Record Type là: A thì Address phải là địa chỉ IP, ví dụ: <strong>8.8.8.8</strong>
        </li>
        <li>
          Nếu Record Type là: CNAME thì Address phải là tên miền , ví dụ: <strong>example.vn</strong>
        </li>
        <li>
          Nếu Record Type là: NS thì Address phải là tên miền , ví dụ: <strong>example.vn</strong>
        </li>
        <li>
          Nếu Record Type là: MX thì Host record phải là @ và Address phải là tên mail server, ví dụ: <strong>mail.example.vn</strong>
        </li>
        <li> Priority chỉ áp dụng cho Type là MX </li>
      </ul>
    </div>
  )
}

function NameServerManage(handleSubmit, onNameServerSubmit) {
  return (
    <React.Fragment>
      <Field label={<strong>DNS 1</strong>} name="ns_content_1" component={RenderInputWithDiv}/>
      <Field label={<strong>DNS 2</strong>} name="ns_content_2" component={RenderInputWithDiv}/>
      <Field label={<strong>DNS 3</strong>} name="ns_content_3" component={RenderInputWithDiv}/>
      <Field label={<strong>DNS 4</strong>} name="ns_content_4" component={RenderInputWithDiv}/>
      <Field label={<strong>DNS 5</strong>} name="ns_content_5" component={RenderInputWithDiv}/>
      <button style={{float: "right"}} onClick={handleSubmit(onNameServerSubmit)} className="btn bg-primary"> Lưu thay đổi</button> 
      <br/>
      <h4>Ghi chú</h4>
      <ul>
        <li>Bắt buộc nhập ít nhất một cặp DNS, cặp DNS này phải tồn tại và hợp lệ. </li>
        <li>DNS mặc định là: <strong>ns1.sdns.vn | ns2.sdns.vn | ns3.sdns.vn</strong></li>
        <li>Để đảm bảo uptime 100% cho tên miền quý khách nên sử dụng tất cả 3 dns</li>
      </ul>
    </React.Fragment>
  )
}

class SdnsConfigPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sdns_data: [],
      is_show_record_config_modal: false,
      record_obj: null,
      user_product_obj: null,
      isLoading: true,
      nameserver_data: [],
      is_loading_nameserver: true
    };
  }

  getUserProductById() {
    const { user_product_id } = this.props.match.params;
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/api/user/service/'+user_product_id,
      withCredentials: true,
    }).then(function (response) {
      self.setState({
        isLoading: false
      })
      if(!response.data.isError) {
        const user_product = response.data.data;
        if(user_product.product && ["VN_DOMAIN", "COM_DOMAIN"].includes(user_product.product.product_type)) {
          self.setState({
            user_product_obj: user_product
          });
          user_product.status == "RUNNING" && self.loadSdnsRecords();
        }
      }
    });
  }

  loadSdnsRecords = () => {
    const { user_product_id } = this.props.match.params;
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/api/user/service/dns/manage',
      withCredentials: true,
      data: {
        user_product_id: user_product_id
      }
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          ...self.state,
          sdns_data: response.data.data
        })
        self.loadNameServer();
      }
    });
  }

  // Tải danh sách nameserver.
  loadNameServer = () => {
    const { user_product_id } = this.props.match.params;
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/api/user/service/dns/nameserver',
      withCredentials: true,
      data: {
        user_product_id: user_product_id
      }
    }).then(function (response) {
      if(!response.data.isError) {
        // Fill dữ liệu NS vào Field.
        self.setInitialNSValues(response.data.data);
        self.setState({
          ...self.state,
          nameserver_data: response.data.data,
          is_loading_nameserver: false
        })
      }
    });
  }
  
  onDeleteRecord = (record_id) => {
    const { user_product_id } = this.props.match.params;
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc muốn xóa record này ?.");
    if(alert_confirm) {
      axios({
        method: 'post',
        url: window.api_url + '/api/user/service/dns/delete/record',
        withCredentials: true,
        data: {
          record_id: record_id,
          user_product_id: user_product_id
        }
      }).then(function (response) {
        if(!response.data.isError) {
          toast.success("Xóa dữ liệu thành công !");
          self.loadSdnsRecords();
        }else {
          toast.error("Có lỗi khi xóa dữ liệu !");
        }
      });
    }
  }
  
  // Hiển thị lên các values có sẳn trong database.
  setInitialNSValues = (name_server_data) => {
    const { updateField } = this.props;
    if(name_server_data) {
      // ns1
      name_server_data[0] && updateField("ns_content_1", name_server_data[0]);
      // ns2
      name_server_data[1] && updateField("ns_content_2", name_server_data[1]);
      // ns3
      name_server_data[2] && updateField("ns_content_3", name_server_data[2]);
      // ns4
      name_server_data[3] && updateField("ns_content_4", name_server_data[3]);
      // ns5
      name_server_data[4] && updateField("ns_content_5", name_server_data[4]);
    }
  }

  componentDidMount() {
    this.getUserProductById();
  }

  // Hiện Modal Popup để cấu hình cho SDNS RECORD
  onShowRecordConfigModal = (record_obj) => {
    this.setState({
      is_show_record_config_modal: true,
      record_obj: record_obj
    });
  }

  onHideModal = () => {
    this.setState({
      is_show_record_config_modal: false,
      record_obj: null
    })
    this.loadSdnsRecords();
  }

  onNameServerSubmit = (values) => {
    const self = this;
    const { user_product_id } = this.props.match.params;
    this.setState({
      isLoading: true
    })
    return axios({
      method: 'post',
      url: window.api_url + '/api/user/service/dns/save/nameserver',
      withCredentials: true,
      data: {
        nameserver_values: values,
        user_product_id: user_product_id
      }
    }).then(function (response) {
      self.setState({
        isLoading: false
      })
      if (!response.data.isError) {
        toast.success("Lưu dữ liệu thành công, vui lòng đợi trong 3-5 phút để dữ liệu được cập nhật. !");
      } else {
        toast.error("Có lỗi trong quá trình lưu Name Server !");
      }
    }); 
  }

  dnsDirectUrl = (domain) => {
    axios({
      method: 'post',
      url: window.api_url + '/api/user/service/dns/manage/' + domain,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        const sdns_login_url = "https://sdns.vn/rest/domain/" + domain + "/login/" + response.data.data;
        window.open(sdns_login_url, '_blank', 'noopener');
      }
    });
  }

  render() {
    const { user_product_id } = this.props.match.params;
    const { handleSubmit } = this.props;
    const {sdns_data, is_show_record_config_modal, record_obj, user_product_obj, isLoading, is_loading_nameserver} = this.state;
    const record_data = _.filter(sdns_data, (i) => !["NS"].includes(i.type));
    return(
      <React.Fragment>
        <ToastContainer />
        {isLoading && <BlockUI/>}
        {!user_product_obj && !isLoading && <div className="card card-body">
          <h6>Dịch vụ không tồn tại !</h6>
        </div>}
        {user_product_obj && user_product_obj.status == "SUSPEND" && !isLoading && <div className="card card-body">
          <h6>Dịch vụ đã SUSPEND !</h6>
        </div>}
        {user_product_obj && user_product_obj.status == "EXPIRED" && !isLoading && <div className="card card-body">
          <h6>Dịch vụ đã hết hạn !</h6>
        </div>}
        {user_product_obj && user_product_obj.status == "RUNNING" && <div>
          <div className="page-header">
            <div className="page-header-content header-elements-md-inline">
              <div className="page-title d-flex">
                <h4>
                  <i className="icon-paragraph-justify2 mr-2"></i>
                  <span className="text-semibold">Cấu hình SDNS</span>
                </h4>
              </div>
            </div>
          </div>
          <br/>
          <div className="card">
            <div className="card-footer">
              <div className="row">
                <div className="col-sm-12">
                <strong>
                  <i style={{fontSize:20}} className="icon-cloud"></i>
                  <span style={{textTransform: "uppercase"}}> {user_product_obj.domain}</span> 
                </strong>
                <strong style={{float: "right"}}>
                  <span onClick={()=> this.dnsDirectUrl(user_product_obj.domain)} style={{color:"#42A5F5", cursor: 'pointer'}}><i className="icon-enter2"></i> SDNS.VN</span>
                </strong>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="tabbable">
                <ul className="nav nav-tabs nav-tabs-highlight nav-justified">
                  <li className="nav-item">
                    <a className="nav-link active" href="#sdns-tab1" data-toggle="tab">Quản Lý Records</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#sdns-tab2" data-toggle="tab">Quản Lý Nameserver</a>
                  </li>
                </ul>
              </div>
              <div className="tab-content">
                <div className="tab-pane active" id="sdns-tab1">
                  {sdns_data && RecordManage(record_data, this.onShowRecordConfigModal, this.onDeleteRecord)}
                </div>
                <div className="tab-pane" id="sdns-tab2">
                  {is_loading_nameserver && <img width="30" src="/assets/img/squares.gif" />}
                  {!is_loading_nameserver && NameServerManage(handleSubmit, this.onNameServerSubmit)}
                </div>
               
              </div>
            </div>
            <div className="card-footer">
            </div>
          </div>
          {is_show_record_config_modal && <SdnsConfigModal
            is_show_record_config_modal title={record_obj ? "Chỉnh sửa record" : "Thêm mới record"} 
            record_obj={record_obj}
            user_product_id={user_product_id}
            user_product_obj={user_product_obj}
            show={is_show_record_config_modal} 
            onHide={this.onHideModal} 
          />}
        </div>}
      </React.Fragment>
    )
  }
}

const SdnsConfigPageWrapper = reduxForm({
  form: 'SdnsConfigPage',
  destroyOnUnmount: true,
  enableReinitialize: true
})(SdnsConfigPage);

const mapState = (state, props) => ({
});

const mapDispatch = (dispatch) => ({
  updateField: (fieldName, value) =>
    dispatch({
      meta: { form: "SdnsConfigPage", field: fieldName },
      payload: value,
      type: "@@redux-form/CHANGE"
    }),
});

export default connect(mapState, mapDispatch)(withRouter(SdnsConfigPageWrapper));